import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Nav.css";
import MediaProductDropdown from "./Showsub1";
import MediaServiceDropdown from "./Showsub2";
import MediaTrainingDropdown from "./Showsub3";

const Nav = ({ onClose }) => {

  const [activeDropdown, setActiveDropdown] = useState(null);

  const toggleDropdown = (menu) => {
    setActiveDropdown(activeDropdown === menu ? null : menu);
  };

  const handleLinkClick = () => {
    setActiveDropdown(null);
    onClose();
  };

  return (
    <div>

      <div className="nav_content_list_media">
        <Link to="/home" className="list_ref_media" onClick={handleLinkClick}>
          Home
        </Link>
      </div>

      {/* PRODUCTS */}
      <div className="nav_content_list_media1">
        <div
          className="list_ref_media"
          onClick={() => toggleDropdown("products")}
          style={{ cursor: "pointer" }}
        >
          Products
          <i
            className={
              activeDropdown === "products"
                ? "fa fa-caret-up"
                : "fa fa-caret-down"
            }
          />
        </div>

        {activeDropdown === "products" && (
          <MediaProductDropdown handleClose={handleLinkClick} />
        )}
      </div>

      {/* SERVICES */}
      <div className="nav_content_list_media1">
        <div
          className="list_ref_media"
          onClick={() => toggleDropdown("services")}
          style={{ cursor: "pointer" }}
        >
          Services
          <i
            className={
              activeDropdown === "services"
                ? "fa fa-caret-up"
                : "fa fa-caret-down"
            }
          />
        </div>

        {activeDropdown === "services" && (
          <MediaServiceDropdown handleClose={handleLinkClick} />
        )}
      </div>

      {/* TRAINING */}
      <div className="nav_content_list_media1">
        <div
          className="list_ref_media"
          onClick={() => toggleDropdown("training")}
          style={{ cursor: "pointer" }}
        >
          Training
          <i
            className={
              activeDropdown === "training"
                ? "fa fa-caret-up"
                : "fa fa-caret-down"
            }
          />
        </div>

        {activeDropdown === "training" && (
          <MediaTrainingDropdown handleClose={handleLinkClick} />
        )}
      </div>

      <div className="nav_content_list_media">
        <Link to="/about-us" className="list_ref_media" onClick={handleLinkClick}>
          About
        </Link>
      </div>

      <div className="nav_content_list_media">
        <Link to="/careers" className="list_ref_media" onClick={handleLinkClick}>
          Career
        </Link>
      </div>

      <div className="nav_content_list_media">
        <Link to="/contact-us" className="list_ref_media" onClick={handleLinkClick}>
          Contact
        </Link>
      </div>

    </div>
  );
};

export default Nav;